export function getFunctionalityName(name) {
    const funcNames = {
        "/inicio": "Acesso a Home",
        "/cadastro": "Menu cadastro",
        "/financeiro/analitica": "Analiticas",
        "/financeiro/backbeat": "Visualizar os dados do backbeat",
        "/financeiro/fundo-sustentabilidade": "Fundo de sustentabilidade",
        "/login": "Logins na plataforma",
        "/recuperacao-senha": "Recuperação de senha",
        "/declaracoes": "Pagina de declarações",
        "/declaracoes/declaracao-cooperado": "Declaração de médico cooperado",
        "/financeiro/recurso-glosas": "Solicitação de revisão de glosas",
        "/painel-economico": "Painel econômico",
        "/financeiro/historico-notas-fiscais": "Histórico de notas fiscais cadastradas",
        "/cadastro/informacoes-pessoais": "Cadastro Informações pessoais",
        "/cadastro/especialidades-medicas": "Cadastro de especialidade médica",
        "/cadastro/local-atendimento": "Cadastro - Local de atendimento",
        "/historico-solicitacoes": "Histórico de solicitações",
        "/cadastro/meios-pagamento": "Cadastro de direcionamento de pagamentos",
        "/alterar": "Redefinição de senha",
        "/beneficios": "Tela de benefícios",
        "/perguntas-frequentes": "Acesso ao FAQ",
        "/financeiro": "Menu Financeiro",
        "/financeiro/cota-capital": "Extrato de cota capital",
        "/consultorio-virtual": "Consultório virtual",
        "/pagina-institucional": "Página institucional",
        "/documentos-atas": "Página de documentos",
        "/cadastro/impostos-alvara": "Atualização cadastral - Impostos (iss e inss)",
        "/beneficios/plano-saude": "Informações plano de saúde cooperado",
        "/beneficios/afastamento": "Afastamento temporário",
        "/financeiro/informe-rendimentos": "Informe de Rendimentos",
        "/declaracoes/inss": "Solicitação de declarações de INSS",
        "/beneficios/benemerito": "Tela de solicitações de benemérito",
        "/auxilio-funeral": "Informações sobre Aux. Funeral",
        "/declaracoes/ltcatpp": "Solciitação de LTCAT",
        "/beneficios/auxilio-temporario": "Auxilio temporário",
        "/declaracoes/outras": "Solcitação de outras declarações",
        "/termos-uso/aceito": "Termo de uso",
        "/declaracoes/iss": "Solicitação de declarações de ISS",
        "/beneficios/outra-solicitacao": "Serviços de outras solicitações",
        "/financeiro/relatorio-glosas-voxis": "Relatório de glosas Voxis",
        "/pagina-treinamento": "Pagina de treinamento",
        "/inicio-vazio": "Acesso Admin",
        "/financeiro/backbeat-saiba-mais": "Backbeat - Saiba Mais",
        "Assistiu vídeo backbeat": "Assistiu vídeo backbeat",
        "Iniciou o video da tela saiba mais sobre o Backbeat.": "Iniciou vídeo backbeat",
        "Acessou a tela de saiba mais sobre o Backbeat.": "Backbeat - Acessou tela saiba mais",
        "/admin/formulario-gestao-treinamento/": "Acessou a tela de gerenciamento de treinamento.",
        "/admin/gestao-certificacoes/": "Acessou a tela de gerenciamento de certificado.",
        "/admin/relatorio-visualizacoes-portal": "Acessou a tela de Relatório de visualizações do Portal.",
        "/financeiro/reembolso-anuidade": "Reembolso de Anuidade",
    }
    const matchedKey = Object.keys(funcNames).find(key => name.startsWith(key));
    const result = matchedKey ? funcNames[matchedKey] : name;
    return result;
}